export default {
	green: '#10BA97',
	white: '#FFFFFF',
	red: '#D94454',
	hyperlink: '#A08AFF',
	buttonDefault: '#795DF5',
	buttonHover: '#947BFF',
	icons: '#5641F2',
};
